import { MainActivity } from "../pages/activity";

const Activity = () => <MainActivity />;

export default Activity;
